import React from 'react';
import arrayMutators from 'final-form-arrays';
import { IntlShape, useIntl } from 'react-intl';

import PageBaseProps from 'types/PageBase';
import FormKeys from 'modules/form/types/FormKeys';
import { QuestionsForm as QuestionsFormType } from 'types/QuestionsForm';

import ConnectedForm from '../ui/ConnectedForm';
import QuestionsFormRender from './QuestionsFormRender';
import PopupErrorForm from '../Errors/PopupErrorForm';
import { setIn } from 'final-form';
import { questionResponseProperty } from '../../types/Question';

const validateForm = (intl: IntlShape) => (
  { questions = [] }: QuestionsFormType,
): object | undefined => questions.reduce((acc, question, index) => {
  if (question.mandatory && !(question.response || question.responses?.length)) {
    return setIn(acc, `questions[${index}].${questionResponseProperty[question.type] }`, intl.formatMessage({
      id: 'validation.required',
      defaultMessage: 'Please answer to continue.',
    }));
  }
  return acc;
}, {});

const QuestionsForm: React.FC<PageBaseProps> = ({ onNext, ...pageProps }) => {
  const intl = useIntl();

  return (
    <ConnectedForm
      onSubmit={onNext}
      formKey={FormKeys.QUESTIONS}
      validate={validateForm(intl)}
      mutators={{ ...arrayMutators }}
      component={QuestionsFormRender}
      subscription={{ hasValidationErrors: true }}
      {...pageProps}
      errorComponent={<PopupErrorForm errorMessage={{
        id: 'questions.mandatoryModal.title',
        defaultMessage: 'You must first answer {count, plural, one {the question} other {all questions}} marked with "{mandatory}".',
      }} />}
    />
  );
};

export default QuestionsForm;
